<div class="ion-text-center grey">
  <ion-icon name="refresh" class="big"></ion-icon>
  <p>
    <ion-icon name="arrow-down"></ion-icon>
    Tirar para actualizar
  </p>
</div>
